import React from 'react';
import { Form } from 'react-bootstrap';

function SimpleText({ label, value, onChange = val => {}, ...props }) {
  return (
    <Form.Group className="form-group">
      <Form.Label>{label}</Form.Label>
      <Form.Control
        value={value}
        onChange={e => onChange(e.target.value)}
        {...props}
      />
    </Form.Group>
  );
}

export default SimpleText;
